import { TwoFactorSmsConfirm } from "@/components/Portal/UserAccount/Security/TwoFactorSmsConfirm";
import { useResendForSmsPhonenumberChange } from "@/hooks/useResendSms";

export const TwoFactorConfirmNumberChange = () => (
  <div className="max-w-[560px]">
    <TwoFactorSmsConfirm useResendAction={useResendForSmsPhonenumberChange} />
  </div>
);
